module.exports = __webpack_public_path__ + "assets/4b51ad71291029752642305afafcc32d.mp4";